// extracted by mini-css-extract-plugin
export var container = "_bv-0";
export var outlet = "_bv-1";
export var outletEnter = "_bv-2";
export var outletEnterActive = "_bv-3";
export var outletExit = "_bv-4";
export var outletExitActive = "_bv-5";